<template>
  <div>
    <div class="p-box">
      <Loading v-if="loading" />
      <div v-else>
        <header class="p-box__header">
          <div class="p-filtersA">
            <div class="p-filtersA__left" />
            <div class="p-filtersA__right">
              <div>
                <router-link :to="{ name: 'CompaniesProducts', params: { company_uuid: companyUuid } }" class="c-button__item c-button__item--outline">
                  {{ $t('pages.CompaniesProductsBulkSet.backIndex') }}
                </router-link>
              </div>
            </div>
          </div>
        </header>
        <div class="p-box__body">
          <div>
            <p class="fontBold">
              {{ $t('pages.CompaniesProductsBulkSet.selectedCount', { count: bulkSetProducts.length }) }}
            </p>
            <div class="p-products">
              <div class="p-products__items">
                <div v-for="product in bulkSetProducts"
                     :key="'product_' + product.id"
                     class="p-products__item"
                >
                  <div class="p-products__itemContainer">
                    <div
                      class="p-photos__image"
                    >
                      <div :style="{ 'background-image': `url(${ product.image })` }" />
                    </div>
                    <div class="p-products__name">
                      {{ product.title }}
                    </div>
                    <div class="p-products__summary">
                      <p>
                        {{ $t('pages.CompaniesProducts.storeCount') }}
                        <UnUsedBadge v-if="product.registeredStoreCount === 0" />
                        <span v-else class="fontBold">
                          {{ $t('labels.simpleStoresCount', { count: product.registeredStoreCount }) }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="selectStores">
            <Info>
              <p>{{ $t('pages.CompaniesProductsBulkSet.info') }}</p>
            </Info>
            <p>
              {{ $t('pages.CompaniesProductsBulkSet.storeCount') }}
              <span class="fontBold">
                {{ storeUuids.length ? $t('labels.simpleStoresCount', { count: storeUuids.length }) : $t('pages.CompaniesProductsBulkSet.pleaseSetStores') }}
              </span>
            </p>
            <div v-show="!selectStoresLoading" class="c-button c-button--icon">
              <label class="c-button__item c-button__item--primary">
                <input
                  class="u-hidden"
                  :disabled="searchAttributesLoading"
                  @click="handleOpenStoreModal"
                >
                <Icon name="iconPlus" class="imageAdd__icon" />
                {{ $t('messages.selectStores') }}
              </label>
            </div>
            <StoreCountFilterModal
              v-if="showStoreCountFilterModal"
              @close="handleCloseFilterModal"
              @submit="handleSubmit"
              @reset="handleReset"
            />
            <StoreModal
              v-if="showStoreModal"
              store-name="companiesProducts"
              @close-store-modal="confirmStoreUuids"
              @back-filter-modal="handleBack"
            />
            <KkProductBulkPreviewModal
              v-if="showPreviewModal"
              :is-visible="showPreviewModal"
              :products="bulkSetProducts"
              @submit="handleSave"
              @close="closePreviewModal"
            />
          </div>
        </div>
        <div class="p-box__footer">
          <div class="c-button c-button--right">
            <KkButton class="button" color="secondary" outlined :text="$t('labels.cancel')" @click="handleCancel" />
            <KkButton
              class="button"
              color="primary"
              :text="$t('labels.save')"
              :disabled="buttonDisabled"
              @click.once="openPreviewModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Info from '../../../components/Info'
import { mapActions, mapMutations, mapState } from 'vuex'
import UnUsedBadge from '../../../components/CompaniesMediaLibraries/UnUsedBadge'
import Loading from '../../../components/Loading'
import StoreModal from '../../../components/StoreModal'
import StoreCountFilterModal from '../../../components/StoreCountFilterModal'
import Icon from '../../../components/Icon'
import { KkProductBulkPreviewModal } from '../../../components/domains/product'
import { KkButton } from '../../../components/base'

export default {
  name: 'CompaniesProductsBulkSet',
  components: {
    Info,
    Loading,
    UnUsedBadge,
    StoreModal,
    StoreCountFilterModal,
    Icon,
    KkProductBulkPreviewModal,
    KkButton
  },
  data() {
    return {
      selectedCategory: null,
      showStoreCountFilterModal: false,
      showStoreModal: false,
      showPreviewModal: false,
      storeUuids: [],
    }
  },
  computed: {
    ...mapState({
      bulkSetProducts: state => state.companiesProducts.bulkSetProducts,
      bulkSetProductsLoading: state => state.companiesProducts.loading,
      selectStoresLoading: state => state.companiesGmbSearchStores.loading || state.companiesSearchTagGroups.loading,
      searchAttributesLoading : state => state.companiesSearchTagGroups.loading,
      brands: state => state.companiesSearchTagGroups.data.brands,
      franchisees: state => state.companiesSearchTagGroups.data.franchisees,
      areas: state => state.companiesSearchTagGroups.data.areas,
      userCompanies: state => state.companiesSearchTagGroups.data.user_companies,
      prefectures : state => state.companiesSearchTagGroups.data.prefectures,
      originalTagGroupA : state => state.companiesSearchTagGroups.data.original_tag_group_a,
      originalTagGroupB : state => state.companiesSearchTagGroups.data.original_tag_group_b,
      originalTagGroupC : state => state.companiesSearchTagGroups.data.original_tag_group_c,
      originalTagGroupD : state => state.companiesSearchTagGroups.data.original_tag_group_d,
      originalTagGroupE : state => state.companiesSearchTagGroups.data.original_tag_group_e,
      bulkOperationsLoading: state => state.companiesProductBulkOperations.loading,
      gmbStores: state => state.companiesGmbStores.data,
      gmbStoresLoading: state => state.companiesGmbStores.loading,
    }),
    companyUuid() { return this.$route.params.company_uuid },
    buttonDisabled() { return this.bulkSetProductsLoading || this.searchAttributesLoading || this.gmbStoresLoading },
    loading() { return this.bulkOperationsLoading || this.bulkSetProductsLoading || this.selectStoresLoading }
  },
  async created() {
    if (this.bulkSetProducts.length === 0){
      this.$router.push({
        name: 'CompaniesProducts',
        params: { company_uuid: this.companyUuid }
      })
      return
    }
    this.setFormValues({ stores: [] })
    await this.readSearchTagGroups()
    this.readStores({companyUuid: this.companyUuid, formValues: {}})
    this.setGmbSearchAttributesFormStoreValues(this.formInitialValues())
    await this.readGmbStores(this.companyUuid)
    this.storeUuids = this.gmbStores ? this.gmbStores.data.map(store => store.attributes.uuid) : []
  },
  methods: {
    ...mapActions({
      bulkUpdate: 'companiesProducts/bulkUpdate',
      readStores: 'companiesGmbSearchStores/readStores',
      readSearchTagGroups: 'companiesSearchTagGroups/readSearchTagGroups',
      createProductStores: 'companiesProductBulkOperations/createProductStores',
      createPreview: 'companiesProducts/createPreview',
      readGmbStores: 'companiesGmbStores/readGmbStores',
    }),
    ...mapMutations({
      setFormValues: 'companiesProducts/setFormValues',
      setGmbSearchAttributesFormStoreValues: 'companiesSearchTagGroups/setFormValues',
    }),
    handleOpenStoreModal() {
      if (this.storeUuids.length !== 0) {
        this.showStoreModal = true
      } else {
        this.showStoreCountFilterModal = true
      }
    },
    handleCloseFilterModal() {
      this.setFormValues({ stores: [...this.storeUuids] })
      this.showStoreCountFilterModal = false
    },
    handleCancel() {
      this.setFormValues({ stores: [] })
      this.$router.go(-1)
    },
    async handleSave() {
      const payload =  {
        product_ids: this.bulkSetProducts.map(v => v.id),
        store_uuids: this.storeUuids,
      }
      const isSuccess = await this.createProductStores(payload)
      if (isSuccess) this.$router.go(-1)
    },
    handleSubmit() {
      this.setFormValues({ stores: this.storeUuids })
      this.showStoreCountFilterModal = false
      this.showStoreModal = true
    },
    handleReset() {
      this.showStoreCountFilterModal = false
    },
    handleBack() {
      this.showStoreModal = false
      this.showStoreCountFilterModal = true
    },
    confirmStoreUuids(storeUuids) {
      this.showStoreModal = false
      this.storeUuids = storeUuids
    },
    formInitialValues() {
      return {
        brands: this.brands.tags.map(v => v.id),
        franchisees: this.franchisees.tags.map(v => v.id),
        areas: this.areas.tags.map(v => v.id),
        user_companies: this.userCompanies.tags.map(v => v.id),
        prefectures: this.prefectures.tags.map(v => v.id),
        original_tag_group_a: this.originalTagGroupA?.tags.map(v => v.id),
        original_tag_group_b: this.originalTagGroupB?.tags.map(v => v.id),
        original_tag_group_c: this.originalTagGroupC?.tags.map(v => v.id),
        original_tag_group_d: this.originalTagGroupD?.tags.map(v => v.id),
        original_tag_group_e: this.originalTagGroupE?.tags.map(v => v.id)
      }
    },
    async openPreviewModal() {
      const payload =  {
        product_ids: this.bulkSetProducts.map(v => v.id),
        store_uuids: this.storeUuids,
      }
      const isSuccess = await this.createPreview(payload)
      if (isSuccess) {
        this.showPreviewModal = true
      }
    },
    closePreviewModal() {
      this.showPreviewModal = false
    },
  },
}
</script>

<style lang="scss" scoped>
.selectStores {
  margin-top: 16px;
  padding: 24px;
  border: 1px solid #E4E7EB;
  border-radius: 4px;
}
.totalCount {
  font-weight: bold;
  margin-bottom: 10px;
}
.p-products{
  &__items{
    display: flex;
    flex-wrap: wrap;
  }
  &__item {
    width: calc(100%/4);
    padding: 20px;
    margin-bottom: 10px;
  }
  &__itemContainer {
    padding: 20px;
    border: 1px solid #e4e7eb;
    border-radius: 4px;
  }
  &__name {
    margin-top: 10px;
    font-weight: bold;
  }
  &____summary {
  padding-bottom: 0;
  p {
    margin: 8px 0;
  }
}
}
.p-photos__image {
  cursor: pointer;
  &--processing {
    opacity: 0.7;
  }
}
.imageAdd__icon {
  width: 16px;
  margin-right: 8px;
}
.fontBold {
  font-weight: bold;
}

.button {
  margin-left: 8px;
}
</style>
